<template>
  <div class="element-insure-item" >
    <div class="cardsection">
      <div class="cardcontainer">

        <template v-if="list.length == 0">
          <div class="card-frame">
              <div class="card noitems">
                <img :src="'../static/info_gray.png'" />
                비교견적 신청내역이 없습니다.<br>
                지금 비교견적을 신청하시겠습니까?
                <button @click="goEstimate">비교견적 신청하기</button>
              </div>
            </div>

        </template>
        <template v-if="list.length > 0 && render">
          <template v-if="$store.state.config.isTouchDevice">
            <carousel :items="1" :nav="false" :dots="true" :margin="11">
              <div class="card" v-for="(item, index) in list" :key="index">
                <router-link :to="{ name: 'InsuranceDetail', query: { index: index, type: (type === '비교견적') ? 'estimate' : ((type === '가입보험') ? 'contract' : (type === '계약변경') ? 'change' : 'accident'), id: item.id, prepared : (list[index].type.indexOf('자동차')!= -1 ) ? 'true' : 'false',auid: item.auid  }  }">
                  <div class="section-insure">
                    <div class="header">
                      <div class="banner">
                        <div :class="[{ estimate: type === '비교견적' ? true : false }, { category: true }]">{{ type }}</div>
                        <div class="type">{{ item.type }}</div>
                      </div>
                      <div class="title">{{ item.title }}</div>
                      <!-- <p v-if="item.endorsement_type" :class="[{ status2: true }]">{{ item.endorsement_type }} {{item.endorsement_date.substr(5,5)}}</p> -->
                      <p v-if="item.accidentType" :class="[{ status3: true }]">{{ item.accidentType }} /</p>
                      <p :class="[{ status: true }, { schema: item.status === '유지' ? true : false }]">{{ item.status }}</p>
                    </div>

                    <div class="body">
                      <div class="body-item" v-if="item.endorsement_type">
                        상태
                        <p>{{ item.endorsement_type }} / {{item.endorsement_date.substr(5,5)}}</p>
                      </div>
                      <div class="body-item" v-if="item.carNumber">
                        차량번호
                        <p>{{ item.carNumber }}</p>
                      </div>

                      <div class="body-item" v-if="!item.carNumber">
                        보험계약자
                        <p>{{ item.user }}</p>
                      </div>

                      <div class="body-item">
                        가입기간
                        <p>{{ item.period_start + " ~ " + item.period_end }}</p>
                      </div>
                    </div>

                  </div>

                  <div class="section-manager">
                    <div class="circle profile"
                      :style="{'background-image': `url(${item.manager.profileUrl})`}"
                      style='background-repeat: no-repeat;background-position: center;background-size:cover;' >
                    </div>
                    <div class="name">
                      {{ item.manager.name }}
                    </div>

                    <div class="circle phone" @click="callPhone(item.manager.phone.replace(/(-)/g,''), $event)">
                      <img :src="'../static/phone.png'" />
                    </div>
                    <div class="circle kakaotalk" @click="openKakao(item.manager.kakaotalk, $event)">
                      <img :src="'../static/kakao.png'" />
                    </div>
                  </div>
                </router-link>
              </div>
            </carousel>
          </template>
          <template v-else>
            <div class="pc-cardview">
                <div class="card-frame" v-for="(item, index) in list">
                  <div class="card">
                    <router-link :to="{ name: 'InsuranceDetail', query: { index: index,  prepared : 'true' ,type: (type === '비교견적') ? 'estimate' : ((type === '가입보험') ? 'contract' : (type === '계약변경') ? 'change' : 'accident'), id: item.id ,  auid: item.auid } }" >
                      <div class="section-insure">
                        <div class="header">
                          <div class="banner">
                            <div :class="[{ estimate: type === '비교견적' ? true : false }, { category: true }]">{{ type }}</div>
                            <div class="type">{{ item.type }}</div>
                          </div>
                          <div class="title">{{ item.title }}</div>
                          <!-- <p v-if="item.endorsement_type" :class="[{ status2: true }]">{{ item.endorsement_type }} {{item.endorsement_date.substr(5,5)}}</p> -->
                          <p v-if="item.accidentType" :class="[{ status3: true }]">{{ item.accidentType }} /</p>

                          <p :class="[{ status: true }, { schema: item.status === '유지' ? true : false }]">{{ item.status }}</p>
                        </div>

                        <div class="body">
                          <div class="body-item" v-if="item.endorsement_type">
                            상태
                            <p>{{ item.endorsement_type }} / {{item.endorsement_date.substr(5,5)}}</p>
                          </div>
                          <div class="body-item" v-if="item.carNumber">
                            차량번호
                            <p>{{ item.carNumber }}</p>
                          </div>

                          <div class="body-item" v-if="!item.carNumber">
                            보험계약자
                            <p>{{ item.user }}</p>
                          </div>

                          <div class="body-item">
                            가입기간
                            <p>{{ item.period_start + " ~ " + item.period_end }}</p>
                          </div>
                        </div>

                      </div>

                      <div class="section-manager">
                        <div class="circle profile"
                          :style="{'background-image': `url(${item.manager.profileUrl})`}"
                          style='background-repeat: no-repeat;background-position: center;background-size:cover;' >
                        </div>
                        <div class="name">
                          {{ item.manager.name }}
                        </div>

                        <div class="circle phone" @click="callPhone(item.manager.phone.replace(/(-)/g,''), $event)">
                          <img :src="'../static/phone.png'" />
                        </div>
                        <div class="circle kakaotalk" @click="openKakao(item.manager.kakaotalk, $event)">
                          <img :src="'../static/kakao.png'" />
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
            </div>
          </template>


        </template>

      </div>
    </div>
  </div>
</template>

<style>
 .owl-theme .owl-nav.disabled + .owl-dots {
    margin-top: -1rem !important;
  }
  .owl-dots .owl-dot {
    width: auto;
  }
</style>

<script>
import carousel from 'vue-owl-carousel'
import moment from 'moment';

export default {
  components: { carousel },
  props: [ "value", "data", "type", "tab" ],
  watch: {
    data: function(newVal, oldVal) {
      this.list = newVal;
      this.render = false;
      this.$nextTick(function () {
        this.render = true;
      })
    }
  },
  data() {
    return {
      render: true,
      list: this.data,
    }
  },
  methods: {
    goEstimate () {
      this.$router.push({ name: 'CompareEstimate', query: { tab: '자동차보험' }  })
    },
    tel(t, e){
      e.preventDefault()
      location.href = "tel:" + t
    },
    openKakao(link, event){
      event.preventDefault()
      window.open(link);
    },
    callPhone(link, event){
      event.preventDefault()
      window.open("tel:" + link);
    },
  }
}
</script>
